<itl-wizard-page
  [pageTitleTransPath]="'crossTherapy.document.addArticle'"
  [isSinglePage]="true"
  (cancelClicked)="cancel()"
  (doneClicked)="save()"
  [pageIsValid]="form?.valid"
>
  <itl-selection
    [(ngModel)]="therapyId"
    [values]="therapySelectionItems"
    title="Therapie"
    placeholder="Bitte wählen Sie eine Therapie aus"
    [required]="true"
    [icon]="therapyIcon"
    [disabled]="disabled"
    (change)="therapyChanged()"
  ></itl-selection>
  <itl-selection
    [(ngModel)]="therapyTypeId"
    [values]="therapyTypeSelectionItems"
    title="Bitte wählen Sie eine Therapieart aus"
    placeholder="Therapieart"
    [required]="true"
    [disabled]="disabled"
    (change)="therapyTypeChanged()"
  ></itl-selection>

  <itl-autocomplete
    *ngIf="showArticleSearch"
    [restriction]="restriction"
    [(selected)]="articleId"
    [useLogicalAnd]="true"
    [required]="true"
    placeholder="Bitte wählen Sie einen Artikel"
    type="article"
    [showDeleteButton]="false"
    title="Artikel"
    (selectedChange)="enhanceArticle($event)"
    [fullPageModal]="true"
    [articleFromDocument]="articleFromDocument"
  >
  </itl-autocomplete>
  <div *ngIf="showArticleData" [style.marginLeft.px]="5">
    <itl-cross-therapy-document-article-data
      [articleLine]="newArticleLine"
      [patient]="patient"
      [showScanButtons]="showScanButtons"
      [showStorageLocation]="showStorageLocation"
      [showIdentificationNumbers]="showIdentificationNumbers && articleRequiresIdentificationNumbers"
      (articleLineChanged)="updateFormControls()"
    ></itl-cross-therapy-document-article-data>
  </div>
</itl-wizard-page>
